module.exports = __webpack_public_path__ + "img/explain_ellipse.15d14bbe.svg";